
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparision",
      function () {
        return require("private-next-pages/comparision/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparision"])
      });
    }
  